module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-toolbar', {
    staticClass: "white elevation-0 mb-2"
  }, [_c('v-toolbar-title', {
    staticStyle: {
      "padding-top": "50px"
    }
  }, [(_vm.disable) ? _c('span', {
    staticClass: "logo"
  }, [_c('img', {
    staticStyle: {
      "margin-bottom": "-6px !important"
    },
    attrs: {
      "src": require("../../img/logo.png"),
      "height": "31"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-weight": "600",
      "color": "#4db6ac"
    }
  }, [_vm._v("Probe Miner")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "13px",
      "padding": "0 0 0 11px"
    }
  }, [_vm._v("Chemical Probes Objective Assessment Resource")])]) : _vm._e(), _vm._v(" "), (!_vm.disable) ? _c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_c('span', {
    staticClass: "logo"
  }, [_c('img', {
    staticStyle: {
      "margin-bottom": "-6px !important"
    },
    attrs: {
      "src": require("../../img/logo.png"),
      "height": "31"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-weight": "600",
      "color": "#4db6ac"
    }
  }, [_vm._v("Probe Miner")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "13px",
      "padding": "0 0 0 11px"
    }
  }, [_vm._v("Chemical Probes Objective Assessment Resource")])])]) : _vm._e()], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.disable) ? _c('div', [_c('v-btn', {
    attrs: {
      "flat": "",
      "disabled": ""
    }
  }, [_vm._v("Home")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "disabled": ""
    }
  }, [_vm._v("About")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "disabled": ""
    }
  }, [_vm._v("Tutorial")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "disabled": ""
    }
  }, [_vm._v("Download")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "disabled": ""
    }
  }, [_vm._v("Limitations")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "disabled": ""
    }
  }, [_vm._v("FAQ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "disabled": ""
    }
  }, [_vm._v("Contact us")])], 1) : _vm._e(), _vm._v(" "), (!_vm.disable) ? _c('div', {
    staticClass: "menu"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-icon', {
    staticStyle: {
      "color": "#455A64",
      "padding-bottom": "2px"
    },
    attrs: {
      "left": ""
    }
  }, [_vm._v("home")]), _vm._v("home")], 1)], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        path: '/about'
      }
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": ""
    }
  }, [_vm._v("About")])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        path: '/tutorial'
      }
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": ""
    }
  }, [_vm._v("Tutorial")])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        path: '/download'
      }
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": ""
    }
  }, [_vm._v("Download")])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        path: '/limitations'
      }
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": ""
    }
  }, [_vm._v("Limitations")])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        path: '/faq'
      }
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": ""
    }
  }, [_vm._v("FAQ")])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        path: '/contact'
      }
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": ""
    }
  }, [_vm._v("Contact")])], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4bafa386"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/prb-toolbar/PrbToolbar.vue
// module id = 558
// module chunks = 1